export default __webpack_public_path__ + "static/media/22t.ceeb2e97.jpg";